import { createFileRoute } from '@tanstack/react-router';
import { AdminGuard } from '@/components/layout/AdminGuard';
import { AdoptionDashboard } from '@/features/admin/adoption/AdoptionDashboard';

/**
 * Admin-only adoption dashboard. Lives under `/metric-hub/*` so it stays in
 * Metric Hub sidebar mode (it's surfaced in the Metric Hub "Review" group,
 * admin-only). Server enforces `requireRole('admin')` on the data endpoint;
 * `<AdminGuard>` gives non-admins a fast 403.
 */
export const Route = createFileRoute('/_authed/metric-hub/adoption')({
  component: AdoptionPage,
});

function AdoptionPage() {
  return (
    <AdminGuard>
      <AdoptionDashboard />
    </AdminGuard>
  );
}
